import {  KoDataTableEdit, KoForm, KoNano, KoTag } from 'packages';
import { useEffect, useState } from 'react';
import styles from './leave.module.scss';
function LeaveTableList({ form, datax }) {
  const start = KoForm.useWatch('start', form);
  const end = KoForm.useWatch('end', form);
  const [totalDays, settotalDays] = useState(0);
  const [dataSource, setDataSource] = useState();

  useEffect(() => {
    if (start && end) {
      const startDate = new Date(start); // Ensure start is a Date object
      const endDate = new Date(end); // Ensure end is a Date object
      const dates = [];
  
      let currentDate = new Date(startDate); // Ensure a fresh Date object
  
      while (currentDate <= endDate) {
        dates.push({
          date: new Date(currentDate), // Store a new Date object
          key: KoNano('lev'),
          leaveDuration: 1
        });
  
        // Move to the next day correctly
        currentDate.setDate(currentDate.getDate() + 1);
      }
  
      settotalDays(dates.length);
  
      let data = form.getFieldsValue();
      data['leaveDates'] = dates;
      console.log(data);
  
      form.setFieldsValue({ leaveDates: dates }); // Fix: Only update 'leaveDates' key
      setDataSource(dates);
    }
  }, [start, end]);
  
  
  


  const columns = [
    {
      dataIndex: 'date',
      title: 'Date',
      width: 150,
      editable: true,
      fixed: 'left',
      widget: 'date'
    },
    {
      dataIndex: 'leaveDuration',
      title: 'Leave Duration',
      editable: true,
      daysAgo: 0,
      widget: 'options',
      width: 150,
      options: [{
        key: 1,
        value: 1,
        label: 'Full-Day'
      }, {
        key: 2,
        value: 2,
        label: 'First Half'
      }, {
        key: 3,
        value: 3,
        label: 'Second Half'
      }]
    }];

  const HandleSave = (newData) => {
    let fullDays = 0;
    let firstHalfDays = 0;
    let secondHalfDays = 0;
    newData.forEach(item => {
      if (item.leaveDuration === 1) {
        fullDays++;
      } else if (item.leaveDuration === 2) {
        firstHalfDays++;
      } else if (item.leaveDuration === 3) {
        secondHalfDays++;
      }
    });
    const totalLeaveDays = fullDays + (firstHalfDays / 2) + (secondHalfDays / 2);
    const leaveSummary = {
      fullDays: fullDays,
      firstHalfDays: firstHalfDays,
      secondHalfDays: secondHalfDays,
      totalLeaveDays: totalLeaveDays
    };
    let data = form.getFieldsValue();
    data['leaveDates'] = newData;
    data['leaveSummary'] = leaveSummary;
    form.setFieldsValue(data);
    setDataSource(newData);
    settotalDays(leaveSummary);
  };
    



  return (
    <div className={styles.leaveTable}>
      {dataSource && <KoDataTableEdit
        dataSource={dataSource}
        form={form}
        maxHeight={40}
        onSave={HandleSave}
        defaultColumns={columns}
      />}
      {totalDays.totalLeaveDays > 0 && <div className={styles.totalDays}>
        <KoTag color='draft' iconFront="CalendarOutlined"  custom={true} value="Full Day" count={totalDays.fullDays} />
        <KoTag color='pending' iconFront="SunOutlined"  custom={true} value="First Half" count={totalDays.firstHalfDays} />
        <KoTag color='add' iconFront="MoonOutlined"  custom={true} value="Second Half" count={totalDays.secondHalfDays} />
        <KoTag color='rejected' iconFront="CalendarOutlined"  custom={true} value="Total Leave" count={totalDays.totalLeaveDays} />
      </div>}
    </div>
  );
}

export default LeaveTableList;